import { ReactNode } from 'react'

type TabPanelsProps = {
  children: ReactNode
  className?: string
}

export const TabPanels = ({ children, className }: TabPanelsProps) => (
  <div className={`mt-6 ${className ?? ''}`}>{children}</div>
)
